
function MoveSelectedItems(listBoxToRemoveFromSelector, listBoxToAddToSelector) {
    var uiLbAddTo = $(listBoxToAddToSelector);
    var uiLbRemoveFrom = $(listBoxToRemoveFromSelector);

    //move the <option> to the other listbox
    uiLbRemoveFrom.children(':selected').appendTo(uiLbAddTo);

    //sort both listboxes
    uiLbAddTo.DotComSort();
    uiLbRemoveFrom.DotComSort();

    //deselect all the selected items
    //alert(uiLbRemoveFrom.selector);
    uiLbAddTo.children(':selected').attr('selected', false);
}

function AddSelectedItemsToSelectedListBox(availableItems, hiddenToStoreValue, storeDescription) {
    var selectedItemsListBox = $(availableItems.replace("_Available", '_Selected'));
    MoveSelectedItems(availableItems, selectedItemsListBox);
    UpdateSelectedListBoxHiddenField(selectedItemsListBox, hiddenToStoreValue, storeDescription);
}

function RemoveSelectedItemsFromSelectedListBox(selectedItems, hiddenToStoreValue, storeDescription) {
    var availableItemsListBox = $(selectedItems.replace('_Selected', '_Available'));
    var selectedItemsListBox = $(selectedItems);
    MoveSelectedItems(selectedItemsListBox, availableItemsListBox);
    UpdateSelectedListBoxHiddenField(selectedItemsListBox, hiddenToStoreValue, storeDescription);
}